// Chuẩn hoá tên riêng về Title Case ("TRẦN TRƯƠNG KIM YẾN"/"đào khánh duy" -> "Trần Trương Kim Yến")
// — cùng convention Title Case backend áp cho applicant. Chỉ dùng cho HIỂN THỊ, không đổi dữ liệu DB.
// toLowerCase/toUpperCase của JS xử lý đúng ký tự có dấu tiếng Việt.
export const titleCaseName = (name: any): string => {
    if (!name) return "";
    return String(name)
        .trim()
        .replace(/\s+/g, " ")
        .toLowerCase()
        .replace(/(^|\s)\S/g, (l) => l.toUpperCase());
};
